// extracted by mini-css-extract-plugin
module.exports = {"cardLabel":"Cards_cardLabel__l0VA0","cardIcon":"Cards_cardIcon__nBYYK"};